export default "__VITE_ASSET__BDA$v4PW__"